import React from 'react';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { translationsSelector } from '../../../selectors';

const useStyles = makeStyles(theme => ({
  subtitle2Bold: {
    ...theme.typography.subtitle2Bold
  },
  subtitle3: {
    ...theme.typography.subtitle3
  },
  body1Bold: {
    ...theme.typography.body1Bold
  },
  body2Bold: {
    ...theme.typography.body2Bold
  },
  primaryContrast: {
    color: theme.palette.primary.contrastText
  },
  secondaryContrast: {
    color: theme.palette.secondary.contrastText
  },
  textDisabled: {
    color: theme.palette.text.disabled
  },
  textHint: {
    color: theme.palette.text.hint
  },
  grey500: {
    color: theme.palette.grey['500']
  },
  warningLight: {
    color: theme.palette.warning.light
  },
  warningDark: {
    color: theme.palette.warning.dark
  }
}));

const CUSTOM_VARIANTS = [
  'subtitle2Bold',
  'subtitle3',
  'body1Bold',
  'body2Bold'
];

const CUSTOM_COLORS = [
  'primaryContrast',
  'secondaryContrast',
  'textDisabled',
  'textHint',
  'grey500',
  'warningLight',
  'warningDark'
];

const Text = ({
  translated,
  className,
  id,
  variant,
  component,
  color,
  align,
  children
}) => {
  const classes = useStyles();
  const translations = useSelector(translationsSelector);

  let variantClass;
  if (CUSTOM_VARIANTS.includes(variant)) {
    variantClass = classes[variant];
  }

  let colorClass;
  if (CUSTOM_COLORS.includes(color)) {
    colorClass = classes[color];
  }

  return (
    <Typography
      className={classNames(variantClass, colorClass, className)}
      id={id}
      variant={variantClass ? undefined : variant}
      component={component}
      color={colorClass ? undefined : color}
      align={align}
    >
      {translated && translations[children] ? translations[children] : children}
    </Typography>
  );
};

export default Text;
